export default __webpack_public_path__ + "static/banner8_mobile-38f0cfb34373c34a07173a656f226c10.png";